import { EmailSealOutlineIcon } from './EmailSealOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 5E7FB53A-EDC8-4FF3-AA66-708C617ECCD6
 * name email-seal-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-seal-outline.svg
 * tags
 */
export const MailSealOutlineIcon = EmailSealOutlineIcon;
export default MailSealOutlineIcon